import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AddTempSaleComponent} from '@app/modules/temp-sale/add-temp-sale/add-temp-sale.component';
import {TempSaleListComponent} from '@app/modules/temp-sale/temp-sale-list/temp-sale-list.component';
import {AuthGuard} from '@app/shared';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'add-temp-sale',
        loadComponent: () => AddTempSaleComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-temp-sale'}
      },
      {
        path: 'add-temp-sale/:/:id',
        loadComponent: () => AddTempSaleComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-temp-sale'}
      },
      {
        path: 'temp-sale-list',
        loadComponent: () => TempSaleListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/temp-sale-list'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TempSaleRoutingModule {
}
